import itemTypeCreateComponent from './item_type.create.component';

let itemTypeCreateModule = angular.module('itemTypeCreate', [
  ])

  .component('itemTypeCreate', itemTypeCreateComponent)
 
  .name;

export default itemTypeCreateModule;



// WEBPACK FOOTER //
// ./client/app/components/item_type/create/index.js